import { chakra, Collapse as ChakraCollapse } from '@chakra-ui/react';

const Collapse = chakra(ChakraCollapse);
export { Collapse };
